import pamakImg from "./Assets/organization_logos/pamak_logo.jpg";
import authImg from "./Assets/organization_logos/auth_logo.jpg";
import ekpaImg from "./Assets/organization_logos/ekpa_logo.jpg";
import datImg from "./Assets/organization_logos/doctoranytime_gr_logo.jpg";
import armySpecialForceImg from "./Assets/organization_logos/greek_special_forces_logo.jpg";
import deloitteImg from "./Assets/organization_logos/deloitte_logo.jpg";
import neunenImg from "./Assets/organization_logos/neunen_logo.jpg";
import istqbImg from "./Assets/organization_logos/istqb_logo.jpg";
import scrumOrgImg from "./Assets/organization_logos/scrum_org_logo.jpg";
import udemyImg from "./Assets/organization_logos/udemy_logo.jpg";
import diplomacyImg from "./Assets/organization_logos/diplomacy_logo.jpg";
import highSchoolImg from "./Assets/organization_logos/7o_sxoleio.jpg";
import stanfordImg from "./Assets/organization_logos/stanford_online_logo.jpg";


export const getLogo = (givenOrganization) => {

    switch (givenOrganization) {

        case "pamak":
            return pamakImg;
        case "auth":
            return authImg;
        case "ekpa":
            return ekpaImg
        case "dat":
            return datImg
        case "army":
            return armySpecialForceImg
        case "deloitte":
            return deloitteImg
        case "neunen":
            return neunenImg
        case "istqb":
            return istqbImg
        case "scrum_org":
            return scrumOrgImg
        case "stanford":
            return stanfordImg
        case "diplomacy":
            return diplomacyImg
        case "high_school":
            return highSchoolImg
        case "udemy":
            return udemyImg
        default:
            throw Error("Wrong organization was given")
    }

}

export const getOrganization = (desiredContent) => {

    const loweredDesiredContent = desiredContent.toLowerCase()

    if (loweredDesiredContent.includes("university") && loweredDesiredContent.includes("macedonia")) {
        return "pamak"
    }
    if (loweredDesiredContent.includes("university") && loweredDesiredContent.includes("aristotle")) {
        return "auth"
    }
    else if (loweredDesiredContent.includes("kapodistriakon")) {
        return "ekpa"
    }
    else if (loweredDesiredContent.includes("doctoranytime")) {
        return "dat"
    }
    else if (loweredDesiredContent.includes("army")) {
        return "army"
    }
    else if (loweredDesiredContent.includes("deloitte")) {
        return "deloitte"
    }
    else if (loweredDesiredContent.includes("neunen")) {
        return "neunen"
    }
    else if (loweredDesiredContent.includes("istqb")) {
        return "istqb"
    }
    else if (loweredDesiredContent.includes("scrum")) {
        return "scrum_org"
    }
    else if (loweredDesiredContent.includes("udemy")) {
        return "udemy"
    }
    else if (loweredDesiredContent.includes("stanford")) {
        return "stanford"
    }
    else if (loweredDesiredContent.includes("diplomacy")) {
        return "diplomacy"
    }
    else if (loweredDesiredContent.includes("high school")) {
        return "high_school"
    }
    else {
        return "wrong"
    }

}